import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Formik } from "formik";
import * as Yup from "yup";
import AlertComponent from "../components/AlertComponent";
import {
  deleteAnalytic,
  editAnalytic,
  getAnalyticTipe,
  postAnalytic,
} from "../redux/action/analyticAction";
import ModalComponent from "../components/ModalComponent";
import { openForm } from "../redux/slice/analyticSlice";
import { SelectInput } from "../components/InputComponent";

const FormAnalytic = ({ param }) => {
  const { idAnalytic, dataByIdAnalytic, isOpenForm, state, dataAnalyticTipe } = useSelector( (state) => state.analytic );
  // console.log(idAnalytic)
  const dispatch = useDispatch();
  const [optionAnalytic, setOptionAnalytic] = useState([])
  const [analyticId, setAnalytic] = useState('')

  const initialValues = {
    analyticWarnMin: idAnalytic === '' ? '' : dataByIdAnalytic.analyticWarnMin,
    analyticWarnMax: idAnalytic === '' ? '' : dataByIdAnalytic.analyticWarnMax,
    analyticId: idAnalytic === '' ? '' : dataByIdAnalytic.analyticId,
    unitId: idAnalytic === '' ? '' : dataByIdAnalytic.unitId,
    analyticName: idAnalytic === '' ? '' : dataByIdAnalytic.analyticName,
    analyticType: idAnalytic === '' ? '' : dataByIdAnalytic.analyticType,
  };
  const validationSchema = Yup.object().shape({
    // analyticId: Yup.string().required("Analytic Id is required!"),
    // analyticWarnMin: Yup.string().required("Analytic Warn Min is required!"),
    // analyticWarnMax: Yup.string().required("Analytic Warn Max is required!"),
    // unitId: Yup.string().required("Unit Id is required!"),
    // analyticName: Yup.string().required("Analytic Name is required!"),
    // analyticType: Yup.string().required("Analytik Tipe is required!"),
  });

  const resetOption = () =>{
    setAnalytic('')
  }

  const handleFormSubmit = async (values) => {
    if (state === "add") {
      param.data = values;
      // console.log(param.data);
      dispatch(postAnalytic(param));
      resetOption()
    } else if (state === "edit") {
      param.data = values;
      param.id = idAnalytic;
      dispatch(editAnalytic(param));
      resetOption()
    } else {
      param.id = idAnalytic;
      dispatch(deleteAnalytic(param));
      resetOption()
    }
  };

  const newAnalytic = () => {
    // console.log(dataSupervisor)
    let arr = [{ name: '- PILIH ANALYTIK -', id: '' }]
    dataAnalyticTipe.map((row, index) => {
      arr.push({ name: row.nameType, id: row.nameType })
    })
    setOptionAnalytic(arr)
    
  }
  useEffect(() => {
    newAnalytic()
  }, [])
  useEffect(() => {
    if (dataAnalyticTipe.length > 0) {
      newAnalytic()
    }
  }, [dataAnalyticTipe])

  useEffect(() => {
    dispatch(getAnalyticTipe(param));
  }, []);

  return state === "delete" ? (
    <AlertComponent
      show={isOpenForm}
      close={() => dispatch(openForm({ open: false, state: "close" }))}
      action={() => handleFormSubmit()}
    />
  ) : (
    <ModalComponent
      title={state === "add" ? "TAMBAH ANALITIK" : "EDIT ANALITIK"}
      show={isOpenForm}
      close={() => dispatch(openForm({ open: false, type: "close" }))}
      idForm="analytic-form"
    >
      <Formik
        onSubmit={handleFormSubmit}
        initialValues={initialValues}
        validationSchema={validationSchema}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
        }) => (
          <form onSubmit={handleSubmit} id="analytic-form">
            <div className="row align-items-center" style={{ color: "white" }}>
              <div className="form-group row mb-3">
                <label
                  htmlFor="staticEmail"
                  className="col-sm-2 col-form-label"
                >
                  Analytik Id
                </label>
                <div className="col-sm-10" style={{ paddingBottom: "10px" }}>
                  <input
                    onChange={handleChange}
                    disabled= 'true'
                    type="text"
                    name="analyticId"
                    id="analyticId"
                    className="form-control"
                    value={values.analyticId}
                    validation={''}
                    props={{
                      onBlur: handleBlur,
                    }}
                  />
                  {touched.analyticId && errors.analyticId && (
                    <span style={{ color: "white" }}>{errors.analyticId}</span>
                  )}
                </div>

                <label
                  htmlFor="staticEmail"
                  className="col-sm-2 col-form-label"
                >
                  Nilai Peringatan Minimum
                </label>
                <div className="col-sm-10" style={{ paddingBottom: "10px" }}>
                  <input
                    onChange={handleChange}
                    type="number"
                    name="analyticWarnMin"
                    id="analyticWarnMin"
                    className="form-control"
                    value={values.analyticWarnMin}
                    validation={''}
                    props={{
                      onBlur: handleBlur,
                    }}
                  />
                  {touched.analyticWarnMin && errors.analyticWarnMin && (
                    <span style={{ color: "white" }}>
                      {errors.analyticWarnMin}
                    </span>
                  )}
                </div>

                <label
                  htmlFor="staticEmail"
                  className="col-sm-2 col-form-label"
                >
                  Nilai Peringatan Maksimum
                </label>
                <div className="col-sm-10" style={{ paddingBottom: "10px" }}>
                  <input
                    onChange={handleChange}
                    type="number"
                    name="analyticWarnMax"
                    id="analyticWarnMax"
                    className="form-control"
                    value={values.analyticWarnMax}
                    validation={''}
                    props={{
                      onBlur: handleBlur,
                    }}
                  />
                  {touched.analyticWarnMax && errors.analyticWarnMax && (
                    <span style={{ color: "white" }}>
                      {errors.analyticWarnMax}
                    </span>
                  )}
                </div>

                <label
                  htmlFor="staticEmail"
                  className="col-sm-2 col-form-label"
                >
                  Unit Id
                </label>
                <div className="col-sm-10" style={{ paddingBottom: "10px" }}>
                  <input
                    onChange={handleChange}
                    disabled= 'true'
                    type="text"
                    name="unitId"
                    id="unitId"
                    className="form-control"
                    value={values.unitId}
                    validation={''}
                    props={{
                      onBlur: handleBlur,
                      disabled: true,
                    }}
                  />
                  {touched.unitId && errors.unitId && (
                    <span style={{ color: "white" }}>{errors.unitId}</span>
                  )}
                </div>

                <label
                  htmlFor="staticEmail"
                  className="col-sm-2 col-form-label"
                >
                  Analytik Name
                </label>
                <div className="col-sm-10" style={{ paddingBottom: "10px" }}>
                  <input
                    onChange={handleChange}
                    disabled= 'true'
                    type="text"
                    name="analyticName"
                    id="analyticName"
                    className="form-control"
                    value={values.analyticName}
                    validation={''}
                    props={{
                      onBlur: handleBlur,
                    }}
                  />
                  {touched.analyticName && errors.analyticName && (
                    <span style={{ color: "white" }}>
                      {errors.analyticName}
                    </span>
                  )}
                </div>

                <label htmlFor="staticEmail" className="col-sm-2 col-form-label" >
                  Analytik Tipe
                </label>
                <div className="col-sm-10" style={{ paddingBottom: "10px" }}>
                    <SelectInput
                      onChange={(e) => {
                        // console.log(e.target.value)
                        let event = { target: { name: 'analyticType', value: e.target.value } }
                          setAnalytic(e.target.value)
                          handleChange(event)
                      }}
                      name="analyticType"
                      id="analyticType"
                      value={values.analyticType}
                      option={optionAnalytic}
                      validation={''} 
                    props={{
                      onBlur: handleBlur,
                      helperText: touched.analyticType && errors.analyticType,
                      error: Boolean(errors.analyticType && touched.analyticType),
                    }}
                    />
                    {touched.analyticType && errors.analyticType && (
                      <span>{errors.analyticType}</span>
                    )}
                </div>
              </div>
            </div>
          </form>
        )}
      </Formik>
    </ModalComponent>
  );
};

export default FormAnalytic;
